<template>
  <div class="w-full aspect-[5/7] flex relative rounded-md overflow-hidden">
    <AsyncImage
      class="w-full h-full object-cover select-none"
      :src="title ? localeCover : placeholders.cover"
      :alt="title ? extractFromLocale(locale, title.attributes.title) : 'cover'"
      @load="$emit('load')"
    />
    <span
      v-if="title?.attributes.type === 'novel' && !hideNovelIcon"
      class="block absolute top-1 right-1 bg-black/50 backdrop-blur p-1 aspect-square rounded-md text-white ring-1 ring-white"
    >
      <IconBook2 />
    </span>
  </div>
</template>

<script setup lang="ts">
import {
  getCoverUrl,
  getLocalizedCoverFromTitleAndCoverRelationships,
  isCoverR,
  isExpanded,
  isTitle,
  type TitleEntity,
} from "~/src/api";
import { IconBook2 } from "@tabler/icons-vue";

const { title, res } = defineProps<{
  title?: TitleEntity;
  res?: "128" | "256" | "512" | "original";
  hideNovelIcon?: boolean;
}>();

defineEmits<{
  (e: "load"): void;
}>();

const { selectLocalizedCover } = useMediaLink();

const { locale, t: translate } = useI18n();
const localeCover = computed(() => {
  if (!title) return;
  return selectLocalizedCover(locale.value, title, res);
});
</script>
